import React, { useEffect, useState } from "react";
import {
    Button,
    Checkbox,
    FormControlLabel,
    InputBase,
    Grid, Typography
} from "@material-ui/core";
import SearchGrid from "../../../../../../../components/table/SearchGrid";

import useStyles from "./styles";
import { withSnackbar } from "../../../../../../../components/Message/Alert";
import { useHistory } from "react-router-dom";
import Loader from "../../../../../../../components/Loader/Loader";

import { PostDataAPI } from '../../../../../../../Services/APIService';

import { SearchOutlined as SearchIcon } from '@material-ui/icons';
//import DisbursementIcon from "../../../../../../../assets/img/icons/disbursement.svg";
import companyLogo from '../../../../../../../assets/img/common/Ellipse 10.png';

import envelopeIcon from '../../../../../../../assets/img/common/envelope-Regular.svg';
import mapMarkerIcon from '../../../../../../../assets/img/common/map-marker-Regular.svg';
import phoneIcon from '../../../../../../../assets/img/common/phone-Regular.svg';
import StarIcon from '@material-ui/icons/Star';
import CompanyImg from '../../../../../../../assets/img/BTDD.png';



function ViewDisbusementDetails({ disbursedId, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;

    let history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const [isApproveClick, setIsApproveClick] = useState(false)
    const [isAuthorizationClick, setIsAuthorizationClick] = useState(false);


    const handleActionClick = (key, item) => {
        if (key == 'Details') {
            setIsApproveClick(true)
        }
        else {
            return ''
        }
    }


    const [isDataRefresh, setIsDataRefresh] = useState(false);

    const handleDataRefresh = () => {
        setIsDataRefresh(!isDataRefresh);
    }

    const [disbursedData, setDisbursedData] = useState([]);


    const [disbursedDetailData, setDisbursedDetailData] = useState([]);

    const loadDetailCollection = () => {
        setIsLoading(true)
        var params = {
            disbursementId: disbursedId
        }
        PostDataAPI("fdngrantdisbursement/get", params).then((result) => {

            setIsLoading(false)
            if (result.success && Array.isArray(result.data)) {
                setDisbursedDetailData(result.data.installments);

                setDisbursedData(result.data)
                handleDataRefresh()
            } else if (result.success && result.data) {

                setDisbursedData([result.data])

                debugger
                console.log(disbursedData)
                setDisbursedDetailData(result.data.installments);
                handleDataRefresh()
            } else {
                setDisbursedDetailData([]);
            }
        });
    };

    useEffect(() => {
        loadDetailCollection()
    }, []);
    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            {/* 
            <Grid container spacing={1}>
               
                <Grid item xs={12} sm={12} md={12} lg={12} className={classes.CardGrid}>
                    <div className={classes.Card}>
                       
                        <div className={classes.CardBg}>
                            <Grid container>
                               
                                <Grid item xs={12} sm={12} className={classes.rightSide}>
                                    <Typography className={classes.ProgramTitle}>Program Name: {disbursedData?.programName}</Typography>

                                </Grid>
                            </Grid>
                        </div>

                    </div>
                </Grid>

            </Grid> */}

            <h2>Disbursement Details</h2>

            <Grid row className={classes.container}>
                <SearchGrid
                    columns="cashDisbursementDetails"
                    list={disbursedData}
                    isGridLoaded={isLoading}
                    noRecordMsg="No record exists."
                    Icon={true}
                    isUpdate={isDataRefresh}
                    isSearchAble={false}
                    onActionClick={handleActionClick}
                />
            </Grid>

            <h2>Installment Details</h2>
            <Grid row className={classes.container}>
                <SearchGrid
                    columns="GranteeDetail"
                    list={disbursedDetailData}
                    noRecordMsg="No record exists."
                    Icon={true}
                    isUpdate={isDataRefresh}
                    onActionClick={handleActionClick}
                />
            </Grid>


        </>
    )
}
export default withSnackbar(ViewDisbusementDetails);